import { API_ROUTE_ADMIN_FEATURE_ACTIVITIES } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export type FeatureDetailsOriginal = {
  id: number
  action: string
  timestamp: string
  customerFeature: {
    id: number
    customer: {
      id: number
      name: string
    }
  }
  user: {
    id: number
    firstName: string
    lastName: string
    email: string
  }
}

export const getFeatureActivities = (featureId: number) =>
  get<FeatureDetailsOriginal[]>(
    API_ROUTE_ADMIN_FEATURE_ACTIVITIES.replace(':featureId', String(featureId)),
    IS_NEW_BACKEND_API
  )
